export function formatUpdated(value: string | undefined, locale: string, template: (date: string) => string) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return template(date.toLocaleDateString(locale, { day: "numeric", month: "short", year: "numeric" }));
}
